import { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { mixPanelToken } from '@gik/core/utils/Analytics';

export default function useMixPanel() {
  useEffect(() => {
    if (mixPanelToken) {
      mixpanel.init(mixPanelToken);
      // TODO: consider identifying the user in mixpanel
    }
  }, []);
  return null;
}
